





import {Vue, Component, Prop} from 'vue-property-decorator'
import {VehicleSlot} from '@/lib/kepler/interfaces'
import ServiceMesh from '@/lib/serviceMesh'
import VuetifyColorHelper from '@/lib/vuetify/VuetifyColorHelper'
import Utils from '@/utils'

@Component({
  components: {
    Layout: Utils.loadComponent('proxy/Layout'),
    Flex: Utils.loadComponent('proxy/Flex'),
    Chip: Utils.loadComponent('proxy/Chip'),
  },
  name: 'VehicleTypeChip',
})
export default class VehicleTypeChip extends Vue {
  @Prop() protected vehicleSlot!: VehicleSlot

  protected get textColor() {
    let contrast = VuetifyColorHelper.lightContrast(VuetifyColorHelper.color(this.vehicleTypeColor.backgroundColor))

    const override = this.$branding.theme.buttonDefaultColorOverride as string | undefined
    if (override) {
      contrast = VuetifyColorHelper.lightContrast(VuetifyColorHelper.color(override))
    }

    return contrast ? 'black' : 'white'
  }

  protected get vehicleType() {
    const sm = new ServiceMesh()
    const key = `${this.vehicleSlot.reservation_type}${this.vehicleSlot.vehicle.category.type}`.toUpperCase()
    return sm.vehicleType[key]
  }

  protected get vehicleTypeColor() {
    const key = `${this.vehicleSlot.reservation_type}${this.vehicleSlot.vehicle.category.type}`.toUpperCase()
    return {backgroundColor: ServiceMesh.colors[key]}
  }
}
